import { getThemeColorHexCode } from './getThemeColorHexCode';
import type { ThemeMode } from '../schema/ThemeMode';
import type { ThemeId } from '../schema/ThemeId';

const THEME_MODE_KEY = 'themeMode';
const THEME_ID_KEY = 'themeId';
const LIGHT_MODE_THEME_COLOR_KEY = 'lightModeThemeColor';
const DARK_MODE_THEME_COLOR_KEY = 'darkModeThemeColor';

/**
 * Sets the theme mode in local storage. Used in index.html for splash screen.
 * @param themeMode
 */
export const setThemeModeInLocalStorage = (themeMode: ThemeMode): void => {
    localStorage.setItem(THEME_MODE_KEY, `${themeMode}`);
};

/**
 * Sets the theme color in local storage. Used in index.html for splash screen.
 * @param themeId
 */
export const setThemeColorInLocalStorage = (themeId: ThemeId): void => {
    localStorage.setItem(LIGHT_MODE_THEME_COLOR_KEY, getThemeColorHexCode(themeId, false));
    localStorage.setItem(DARK_MODE_THEME_COLOR_KEY, getThemeColorHexCode(themeId, true));
};

/**
 * Gets the theme id from local storage temporarily till we have the backend setting.
 * @returns
 */
export const getThemeIdFromLocalStorage = (): string => {
    return localStorage.getItem(THEME_ID_KEY);
};

/**
 * Sets the themeId in local storage temporarily till we have the backend setting.
 * @param themeId
 */
export const setThemeIdInLocalStorage = (themeId: ThemeId): void => {
    localStorage.setItem(THEME_ID_KEY, themeId);
};
